import { FunctionComponent, useMemo } from "react";
import {
	HorizontalCardSelect,
	HorizontalCardSelectProps,
} from "./horizontal-card-select";
import { Property } from "src/common";
import { useUiData } from "src/ui/data/use-ui-data";

export const StockAwareHorizontalCardSelect: FunctionComponent<
	HorizontalCardSelectProps
> = (props) => {
	const { getStockHiddenValues } = useUiData();
	const { property, fieldValues = [], hiddenValues } = props;

	const mergedHidden = useMemo(() => {
		const base = hiddenValues ?? [];
		if (!property) {
			return base;
		}
		const stockHidden = getStockHiddenValues(property as Property, fieldValues);
		return stockHidden.length > 0 ? [...base, ...stockHidden] : base;
	}, [property, fieldValues, hiddenValues, getStockHiddenValues]);

	return <HorizontalCardSelect {...props} hiddenValues={mergedHidden} />;
};
